import { IApplicationState } from '../../types/redux';

export function selectPuids(state: IApplicationState) {
  if (state.developer) {
    return state.developer.puids;
  }

  if (state.developerV2.templateSpecialPromo) {
    const puids = state.developerV2.templateSpecialPromo.puids;

    if (puids) {
      return {
        ...puids,
        puid5: puids.puid5 ?? /* istanbul ignore next */ undefined,
        puid39: puids.puid39 ?? /* istanbul ignore next */ undefined,
      };
    }
  }

  return null;
}
